// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthView_container_3aunR","logoContainer":"AuthView_logoContainer_3aYS8","textContainer":"AuthView_textContainer_3c1xk","formContainer":"AuthView_formContainer_2-Ukr"};